import { render } from "./Costi.vue?vue&type=template&id=733d0302"
import script from "./Costi.vue?vue&type=script&lang=js"
export * from "./Costi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__